export default __webpack_public_path__ + "static/media/plus-black.05e900b7.svg";